
const SKELETON = "bg-[linear-gradient(90deg,rgba(255,255,255,0.05),rgba(255,255,255,0.11),rgba(255,255,255,0.05))] bg-[length:200%_100%] animate-shimmer"

const ChaseLoader = () => {
    return (
        <div className="w-full max-w-[520px] surface-card px-4 py-6 sm:px-8 sm:py-8 animate-fade-in" role="status" aria-label="Loading your documents">
            <div className='flex flex-col items-center'>
                <div className={`${SKELETON} w-56 h-8 rounded-xl`} />
            </div>
            <div className={`${SKELETON} w-full h-[120px] mt-10 rounded-card`} />
            <div className={`${SKELETON} w-full h-1.5 mt-8 rounded-full`} />
            <div className='mt-4 flex flex-col gap-2.5'>
                {[0, 1, 2].map((row) => <div key={row} className={`${SKELETON} w-full h-[70px] rounded-card`} style={{ animationDelay: `${row * 140}ms` }} />)}
            </div>
            <div className={`${SKELETON} w-full h-[56px] mt-8 rounded-full`} />
        </div>
    )
}

export default ChaseLoader
